/* eslint-disable @typescript-eslint/no-explicit-any */
import { UhfFooterMode, UhfHeaderMode } from "../models";
import { UhfState } from "./state";

export const getUhfState = (state: any): UhfState => state.uhf;

export const getUhfData = (state: any) => getUhfState(state).data;

export const getUhfCssTag = (state: any): string | undefined => getUhfData(state)?.cssIncludes;

export const getUhfJavascriptTag = (state: any): string | undefined =>
  getUhfData(state)?.javascriptIncludes;

export const getUhfHeader = (state: any): string | undefined => getUhfData(state)?.headerHtml;

export const getUhfFooter = (state: any): string | undefined => getUhfData(state)?.footerHtml;

export const getUhfHeaderMode = (state: any): UhfHeaderMode => getUhfState(state).headerMode;

export const getUhfFooterMode = (state: any): UhfFooterMode =>
  getUhfState(state).footerMode || UhfFooterMode.Full;
